import React from 'react';

import { Trigger } from '../components';

export const BannerTrigger = () => <Trigger shouldNotRenderAt="desktop" />;
